// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file nodebase/v1/public_web.proto (package nodebase.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { RequestMeta } from "./common_pb";
import { file_nodebase_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nodebase/v1/public_web.proto.
 */
export const file_nodebase_v1_public_web: GenFile = /*@__PURE__*/
  fileDesc("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", [file_nodebase_v1_common]);

/**
 * @generated from message nodebase.v1.PublicWebEndpoint
 */
export type PublicWebEndpoint = Message<"nodebase.v1.PublicWebEndpoint"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string worker_id = 3;
   */
  workerId: string;

  /**
   * @generated from field: string hostname = 4;
   */
  hostname: string;

  /**
   * @generated from field: uint32 target_port = 5;
   */
  targetPort: number;

  /**
   * @generated from field: nodebase.v1.PublicWebDesiredState desired_state = 6;
   */
  desiredState: PublicWebDesiredState;

  /**
   * @generated from field: uint64 config_version = 7;
   */
  configVersion: bigint;

  /**
   * @generated from field: string suspension_reason = 8;
   */
  suspensionReason: string;

  /**
   * @generated from field: int64 created_unix = 9;
   */
  createdUnix: bigint;

  /**
   * @generated from field: int64 updated_unix = 10;
   */
  updatedUnix: bigint;

  /**
   * Included on status reads; absent on older servers.
   *
   * @generated from field: nodebase.v1.ManagePublicWebDomainResponse custom_domain = 11;
   */
  customDomain?: ManagePublicWebDomainResponse | undefined;

  /**
   * Empty/web retains website compatibility; files is an independent endpoint.
   *
   * @generated from field: string kind = 12;
   */
  kind: string;
};

/**
 * Describes the message nodebase.v1.PublicWebEndpoint.
 * Use `create(PublicWebEndpointSchema)` to create a new message.
 */
export const PublicWebEndpointSchema: GenMessage<PublicWebEndpoint> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 0);

/**
 * @generated from message nodebase.v1.PublishPublicWebRequest
 */
export type PublishPublicWebRequest = Message<"nodebase.v1.PublishPublicWebRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: uint32 target_port = 2;
   */
  targetPort: number;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;
};

/**
 * Describes the message nodebase.v1.PublishPublicWebRequest.
 * Use `create(PublishPublicWebRequestSchema)` to create a new message.
 */
export const PublishPublicWebRequestSchema: GenMessage<PublishPublicWebRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 1);

/**
 * @generated from message nodebase.v1.PublishPublicWebResponse
 */
export type PublishPublicWebResponse = Message<"nodebase.v1.PublishPublicWebResponse"> & {
  /**
   * @generated from field: nodebase.v1.PublicWebEndpoint endpoint = 1;
   */
  endpoint?: PublicWebEndpoint | undefined;
};

/**
 * Describes the message nodebase.v1.PublishPublicWebResponse.
 * Use `create(PublishPublicWebResponseSchema)` to create a new message.
 */
export const PublishPublicWebResponseSchema: GenMessage<PublishPublicWebResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 2);

/**
 * @generated from message nodebase.v1.GetPublicWebRequest
 */
export type GetPublicWebRequest = Message<"nodebase.v1.GetPublicWebRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: string kind = 2;
   */
  kind: string;
};

/**
 * Describes the message nodebase.v1.GetPublicWebRequest.
 * Use `create(GetPublicWebRequestSchema)` to create a new message.
 */
export const GetPublicWebRequestSchema: GenMessage<GetPublicWebRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 3);

/**
 * @generated from message nodebase.v1.GetPublicWebResponse
 */
export type GetPublicWebResponse = Message<"nodebase.v1.GetPublicWebResponse"> & {
  /**
   * @generated from field: nodebase.v1.PublicWebEndpoint endpoint = 1;
   */
  endpoint?: PublicWebEndpoint | undefined;

  /**
   * @generated from field: bool supports_files = 2;
   */
  supportsFiles: boolean;
};

/**
 * Describes the message nodebase.v1.GetPublicWebResponse.
 * Use `create(GetPublicWebResponseSchema)` to create a new message.
 */
export const GetPublicWebResponseSchema: GenMessage<GetPublicWebResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 4);

/**
 * @generated from message nodebase.v1.SetPublicWebStateRequest
 */
export type SetPublicWebStateRequest = Message<"nodebase.v1.SetPublicWebStateRequest"> & {
  /**
   * @generated from field: nodebase.v1.RequestMeta meta = 1;
   */
  meta?: RequestMeta | undefined;

  /**
   * @generated from field: nodebase.v1.PublicWebDesiredState desired_state = 2;
   */
  desiredState: PublicWebDesiredState;

  /**
   * @generated from field: string kind = 3;
   */
  kind: string;
};

/**
 * Describes the message nodebase.v1.SetPublicWebStateRequest.
 * Use `create(SetPublicWebStateRequestSchema)` to create a new message.
 */
export const SetPublicWebStateRequestSchema: GenMessage<SetPublicWebStateRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 5);

/**
 * @generated from message nodebase.v1.SetPublicWebStateResponse
 */
export type SetPublicWebStateResponse = Message<"nodebase.v1.SetPublicWebStateResponse"> & {
  /**
   * @generated from field: nodebase.v1.PublicWebEndpoint endpoint = 1;
   */
  endpoint?: PublicWebEndpoint | undefined;
};

/**
 * Describes the message nodebase.v1.SetPublicWebStateResponse.
 * Use `create(SetPublicWebStateResponseSchema)` to create a new message.
 */
export const SetPublicWebStateResponseSchema: GenMessage<SetPublicWebStateResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 6);

/**
 * PublicWebRoute is the complete authoritative hostname table sent to an
 * Ingress. An empty authoritative list withdraws every old route.
 *
 * @generated from message nodebase.v1.PublicWebRoute
 */
export type PublicWebRoute = Message<"nodebase.v1.PublicWebRoute"> & {
  /**
   * @generated from field: string endpoint_id = 1;
   */
  endpointId: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string worker_id = 3;
   */
  workerId: string;

  /**
   * @generated from field: string hostname = 4;
   */
  hostname: string;

  /**
   * @generated from field: uint64 config_version = 5;
   */
  configVersion: bigint;

  /**
   * Platform connection challenge; probe_only controls business forwarding.
   *
   * @generated from field: string probe_token = 6;
   */
  probeToken: string;

  /**
   * @generated from field: int64 valid_until_unix = 7;
   */
  validUntilUnix: bigint;

  /**
   * @generated from field: bool probe_only = 8;
   */
  probeOnly: boolean;

  /**
   * @generated from field: uint64 placement_revision = 9;
   */
  placementRevision: bigint;

  /**
   * @generated from field: uint64 worker_generation = 10;
   */
  workerGeneration: bigint;

  /**
   * @generated from field: uint64 lease_epoch = 11;
   */
  leaseEpoch: bigint;
};

/**
 * Describes the message nodebase.v1.PublicWebRoute.
 * Use `create(PublicWebRouteSchema)` to create a new message.
 */
export const PublicWebRouteSchema: GenMessage<PublicWebRoute> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 7);

/**
 * PublicWebTunnelAssignment is a short-lived Worker attachment. The signed
 * ticket authenticates the outbound tunnel; target_port is consumed only by
 * the Worker Agent and is never accepted from the tunnel peer.
 *
 * @generated from message nodebase.v1.PublicWebTunnelAssignment
 */
export type PublicWebTunnelAssignment = Message<"nodebase.v1.PublicWebTunnelAssignment"> & {
  /**
   * @generated from field: string endpoint_id = 1;
   */
  endpointId: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string hostname = 3;
   */
  hostname: string;

  /**
   * @generated from field: uint32 target_port = 4;
   */
  targetPort: number;

  /**
   * @generated from field: uint64 config_version = 5;
   */
  configVersion: bigint;

  /**
   * @generated from field: string edge_node_id = 6;
   */
  edgeNodeId: string;

  /**
   * @generated from field: repeated nodebase.v1.PublicWebIngressEndpoint endpoints = 7;
   */
  endpoints: PublicWebIngressEndpoint[];

  /**
   * @generated from field: string route_ticket = 8;
   */
  routeTicket: string;

  /**
   * @generated from field: int64 expires_unix = 9;
   */
  expiresUnix: bigint;
};

/**
 * Describes the message nodebase.v1.PublicWebTunnelAssignment.
 * Use `create(PublicWebTunnelAssignmentSchema)` to create a new message.
 */
export const PublicWebTunnelAssignmentSchema: GenMessage<PublicWebTunnelAssignment> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 8);

/**
 * @generated from message nodebase.v1.PublicWebIngressEndpoint
 */
export type PublicWebIngressEndpoint = Message<"nodebase.v1.PublicWebIngressEndpoint"> & {
  /**
   * @generated from field: string host = 1;
   */
  host: string;

  /**
   * @generated from field: uint32 port = 2;
   */
  port: number;

  /**
   * @generated from field: string server_name = 3;
   */
  serverName: string;
};

/**
 * Describes the message nodebase.v1.PublicWebIngressEndpoint.
 * Use `create(PublicWebIngressEndpointSchema)` to create a new message.
 */
export const PublicWebIngressEndpointSchema: GenMessage<PublicWebIngressEndpoint> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 9);

/**
 * Worker-scoped; no client-supplied Workspace authority.
 *
 * @generated from message nodebase.v1.ManagePublicWebDomainRequest
 */
export type ManagePublicWebDomainRequest = Message<"nodebase.v1.ManagePublicWebDomainRequest"> & {
  /**
   * add, status, verify, remove
   *
   * @generated from field: string action = 1;
   */
  action: string;

  /**
   * @generated from field: string hostname = 2;
   */
  hostname: string;
};

/**
 * Describes the message nodebase.v1.ManagePublicWebDomainRequest.
 * Use `create(ManagePublicWebDomainRequestSchema)` to create a new message.
 */
export const ManagePublicWebDomainRequestSchema: GenMessage<ManagePublicWebDomainRequest> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 10);

/**
 * @generated from message nodebase.v1.ManagePublicWebDomainResponse
 */
export type ManagePublicWebDomainResponse = Message<"nodebase.v1.ManagePublicWebDomainResponse"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: string hostname = 2;
   */
  hostname: string;

  /**
   * @generated from field: string cname_target = 3;
   */
  cnameTarget: string;

  /**
   * @generated from field: string txt_name = 4;
   */
  txtName: string;

  /**
   * @generated from field: string txt_value = 5;
   */
  txtValue: string;

  /**
   * @generated from field: string state = 6;
   */
  state: string;

  /**
   * @generated from field: string next_action = 7;
   */
  nextAction: string;

  /**
   * @generated from field: string last_error = 8;
   */
  lastError: string;

  /**
   * @generated from field: int64 checked_unix = 9;
   */
  checkedUnix: bigint;

  /**
   * @generated from field: string tls_mode = 10;
   */
  tlsMode: string;

  /**
   * @generated from field: int64 valid_until_unix = 11;
   */
  validUntilUnix: bigint;

  /**
   * @generated from field: string website_state = 12;
   */
  websiteState: string;
};

/**
 * Describes the message nodebase.v1.ManagePublicWebDomainResponse.
 * Use `create(ManagePublicWebDomainResponseSchema)` to create a new message.
 */
export const ManagePublicWebDomainResponseSchema: GenMessage<ManagePublicWebDomainResponse> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 11);

/**
 * Readiness is scoped to an exact route and runtime authority, never a node-wide
 * session counter. A disconnected tunnel cannot acknowledge a new placement.
 *
 * @generated from message nodebase.v1.PublicWebIngressObservation
 */
export type PublicWebIngressObservation = Message<"nodebase.v1.PublicWebIngressObservation"> & {
  /**
   * @generated from field: string endpoint_id = 1;
   */
  endpointId: string;

  /**
   * @generated from field: uint64 config_version = 2;
   */
  configVersion: bigint;

  /**
   * @generated from field: uint64 placement_revision = 3;
   */
  placementRevision: bigint;

  /**
   * @generated from field: uint64 worker_generation = 4;
   */
  workerGeneration: bigint;

  /**
   * @generated from field: uint64 lease_epoch = 5;
   */
  leaseEpoch: bigint;

  /**
   * @generated from field: bool tunnel_connected = 6;
   */
  tunnelConnected: boolean;
};

/**
 * Describes the message nodebase.v1.PublicWebIngressObservation.
 * Use `create(PublicWebIngressObservationSchema)` to create a new message.
 */
export const PublicWebIngressObservationSchema: GenMessage<PublicWebIngressObservation> = /*@__PURE__*/
  messageDesc(file_nodebase_v1_public_web, 12);

/**
 * @generated from enum nodebase.v1.PublicWebDesiredState
 */
export enum PublicWebDesiredState {
  /**
   * @generated from enum value: PUBLIC_WEB_DESIRED_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PUBLIC_WEB_DESIRED_STATE_PUBLISHED = 1;
   */
  PUBLISHED = 1,

  /**
   * @generated from enum value: PUBLIC_WEB_DESIRED_STATE_PAUSED = 2;
   */
  PAUSED = 2,

  /**
   * Removed withdraws traffic but retains the Workspace's hostname forever.
   *
   * @generated from enum value: PUBLIC_WEB_DESIRED_STATE_REMOVED = 3;
   */
  REMOVED = 3,

  /**
   * Suspended is Control-owned and cannot be cleared by a Worker.
   *
   * @generated from enum value: PUBLIC_WEB_DESIRED_STATE_SUSPENDED = 4;
   */
  SUSPENDED = 4,
}

/**
 * Describes the enum nodebase.v1.PublicWebDesiredState.
 */
export const PublicWebDesiredStateSchema: GenEnum<PublicWebDesiredState> = /*@__PURE__*/
  enumDesc(file_nodebase_v1_public_web, 0);

/**
 * PublicWebService owns the one public HTTPS endpoint a Workspace may publish.
 * MVP callers are authenticated Workers; the resource belongs to the
 * Workspace so its hostname survives Worker rebuilds and later replacement.
 *
 * @generated from service nodebase.v1.PublicWebService
 */
export const PublicWebService: GenService<{
  /**
   * @generated from rpc nodebase.v1.PublicWebService.ManagePublicWebDomain
   */
  managePublicWebDomain: {
    methodKind: "unary";
    input: typeof ManagePublicWebDomainRequestSchema;
    output: typeof ManagePublicWebDomainResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.PublicWebService.PublishPublicWeb
   */
  publishPublicWeb: {
    methodKind: "unary";
    input: typeof PublishPublicWebRequestSchema;
    output: typeof PublishPublicWebResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.PublicWebService.GetPublicWeb
   */
  getPublicWeb: {
    methodKind: "unary";
    input: typeof GetPublicWebRequestSchema;
    output: typeof GetPublicWebResponseSchema;
  },
  /**
   * @generated from rpc nodebase.v1.PublicWebService.SetPublicWebState
   */
  setPublicWebState: {
    methodKind: "unary";
    input: typeof SetPublicWebStateRequestSchema;
    output: typeof SetPublicWebStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_nodebase_v1_public_web, 0);

